import { privateFetch } from "../libs/axios"
import {
  AffiliateCommissionsType,
  AffiliateInvoice,
  CommissionsInvoice,
  CreateAffiliateRequestType,
  EditAffiliateRequestType,
  GenerateInvoiceRequest,
  GetAffiliateResponseType,
  GetAffiliatesResponseType,
} from "../types/AffiliateTypes"
import { jsonToQueryString } from "../utils/Common"

export const getAllAffiliates = async (search = "") =>
  await privateFetch().get<GetAffiliatesResponseType>(
    `/api/v1/tenant/affiliate?filter[search]=${search}`
  )

export const createAffiliate = async (body: CreateAffiliateRequestType) =>
  await privateFetch().post<GetAffiliatesResponseType>("/api/v1/user-invitation", body)

export const updateAffiliate = async (id: string, body: EditAffiliateRequestType) =>
  await privateFetch().put<GetAffiliatesResponseType>(`/api/v1/tenant/affiliate/${id}`, body)

export const getAllAffiliateByFilter = async (filter = {}) =>
  await privateFetch().get<GetAffiliatesResponseType>(
    `/api/v1/tenant/affiliate/${jsonToQueryString(filter)}`
  )

export const getAffiliateById = async (id: string) =>
  await privateFetch().get<GetAffiliateResponseType>(`/api/v1/tenant/affiliate/${id}`)

export const getAffiliateCommissions = async (id: string, params: CommissionsInvoice) =>
  await privateFetch().get<AffiliateCommissionsType>(`/api/v1/affiliate/${id}/commissions`, {
    params,
  })

export const getAffiliatesCommissions = async (params: CommissionsInvoice) =>
  await privateFetch().get<AffiliateCommissionsType>(`/api/v1/affiliate/commissions`, { params })

export const getAffiliateInvoices = async (params: CommissionsInvoice) =>
  await privateFetch().get<AffiliateCommissionsType>(`/api/v1/affiliate/invoices`, { params })

export const generateInvoice = async (affiliateId: string, body: GenerateInvoiceRequest) =>
  await privateFetch().post<AffiliateInvoice>(
    `/api/v1/affiliate/${affiliateId}/generate-invoice`,
    body
  )

export const updateInvoice = async (id: string, body: any) =>
  await privateFetch().post<any>(`/api/v1/affiliate/invoice/${id}`, body)

export const getCommissionsInvoice = async (id: string | string[]) =>
  await privateFetch().get<AffiliateCommissionsType>(`/api/v1/affiliate/invoice/${id}`)

export const getCommissionsInvoiceForPdf = async (
  invoiceId: string,
  headers?: Record<string, string>
) =>
  await privateFetch().get<AffiliateCommissionsType>(`api/v1/invoice/affiliate/${invoiceId}`, {
    headers,
  })

export const getCommissionsInvoices = async (affiliateId: string, params: CommissionsInvoice) =>
  await privateFetch().get<AffiliateCommissionsType>(`/api/v1/affiliate/${affiliateId}/invoices`, {
    params,
  })

export const getBookings = async (affiliateId: string) =>
  await privateFetch().get<AffiliateCommissionsType>(`/api/v1/affiliate/${affiliateId}/bookings`)

export const getOrders = async (affiliateId: string) =>
  await privateFetch().get<AffiliateCommissionsType>(`/api/v1/affiliate/${affiliateId}/orders`)

export const downloadInvoice = async (invoiceId: string, headers?: Record<string, string>) =>
  await privateFetch().get(`api/v1/affiliate/${invoiceId}/pdf`, {
    responseType: "arraybuffer",
    headers,
  })
